import {call, put, select, take, fork} from "redux-saga/effects";
import {CODES} from "../../constants";
import {getCurrentStore, getUserInfo} from "../../reducers/app";
import API from "../../api/api";
import {getFilters, getOrderPageParam} from "../../reducers/orders";
import {toast} from "react-toastify";
import {globalIntl} from "../App/App";
import {getIndexStat} from "../DashBoard/saga";

export function *getOrders(object: any): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    let filters = {...yield select(getFilters)}
    for (var key in filters){
        if(filters[key] === -1 || !filters){
            filters[key] = null
        }
    }
    let pageParams = yield select(getOrderPageParam)
    let currentStore = yield select(getCurrentStore)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...pageParams,
        ...filters,
        ...object.pageParams,
        storeId: currentStore,
        exportFlag: object.type === 'export' ? 1 : 0
    }
    let resp = yield call(API.getOrderList, params)
    if (resp.code === CODES.SUCCESS && resp.data) {
        yield put({type: 'SET_ORDERS', payload: {data: resp.data, pageParams: object.pageParams}})
    }
}

function *getOrderDetail(data: any): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...data
    }
    let resp = yield call(API.getOrderDetail, params)
    if (resp.code === CODES.SUCCESS && resp.data) {
        yield put({type: 'SET_ORDER_DETAIL', payload: {data: resp.data}})
    }
}

function *refund(data: any): Generator<any, void, any>{
    let userInfo = yield select(getUserInfo)
    let {origin, ...rest} = data
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...rest
    }
    let resp = yield call(API.refund, params)
    if (resp.code === CODES.SUCCESS) {
        yield put({type: 'REFUND_SUCC', payload: {data: data}})
        yield toast.success(globalIntl.formatMessage({id: 'refundSucc'}))
        if(origin === 'orders'){
            yield fork(getOrders, {})
        }else if(origin === 'dashboard'){
            yield fork(getIndexStat)

        }
    }
}

export function *watchOrders(){
    while (true) {
        let {payload} = yield take('GET_ORDERS')
        if(payload.type === 'detail'){
            yield fork(getOrderDetail, payload.data)
        } else {
            yield fork(getOrders, payload)
        }
    }
}

export function *watchRefund(){
    while (true) {
        let {payload} = yield take('REFUND')
        yield fork(refund, payload)
    }
}